import { render, staticRenderFns } from "./SupplierRawMaterialBiologicallyActivePrinciples.vue?vue&type=template&id=04a2ea13&scoped=true&"
import script from "./SupplierRawMaterialBiologicallyActivePrinciples.vue?vue&type=script&lang=js&"
export * from "./SupplierRawMaterialBiologicallyActivePrinciples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a2ea13",
  null
  
)

export default component.exports